import script from "./SimpleTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__